import { createSelector } from 'reselect'

export const getRegionsLoading = createSelector(
  (state) => Boolean(state.geoObjects && state.geoObjects.regions && state.geoObjects.regions.isLoading),
  (isLoading) => isLoading
)
